import { Howl } from 'howler';
import { useEffect, useRef } from 'react';
import { ALL_SOUND_ASSET_URLS } from '../assets/soundAssetUrls';
import { isConfigFlagEnabled } from '../config';
import { IMAGE_ASSET_URLS } from '../utils/loaderUtils';
import { useDocumentLoaded } from './useDocumentLoaded';
function getHeadPreloadableAssets() {
    const preloadableAssets = Object.values(IMAGE_ASSET_URLS).map((url) => ({ url, type: 'image' }));
    if (isConfigFlagEnabled('preloadSoundsWithHeadTags')) {
        // Preloading audio files may not work in browsers right now, throws an error about unsupported 'as' value.
        // TODO: Revisit this in the future to see if it works.
        preloadableAssets.push(...Object.values(ALL_SOUND_ASSET_URLS).map((url) => ({ url, type: 'audio' })));
    }
    return preloadableAssets;
}
function preloadAssetInHead({ url, type }) {
    const linkElement = document.createElement('link');
    linkElement.setAttribute('rel', 'preload');
    linkElement.setAttribute('href', url);
    linkElement.setAttribute('as', type);
    document.head.appendChild(linkElement);
}
function preloadAssetsInHead() {
    const headPreloadableAssets = getHeadPreloadableAssets();
    console.log(`Adding ${headPreloadableAssets.length} preload asset head tags...`);
    headPreloadableAssets.forEach(preloadAssetInHead);
}
function maybePreloadSoundsWithHowler() {
    if (isConfigFlagEnabled('preloadSoundsWithHeadTags')) {
        return;
    }
    const soundUrlsToPreload = Object.values(ALL_SOUND_ASSET_URLS);
    console.log(`Preloading ${soundUrlsToPreload.length} sound(s)...`);
    soundUrlsToPreload.forEach((soundUrl) => {
        new Howl({
            src: [soundUrl],
            preload: true,
            autoplay: false
        });
    });
}
export function useAssetPreload() {
    const hasPreloadStarted = useRef(false);
    const isDocumentLoaded = useDocumentLoaded();
    useEffect(() => {
        if (!isDocumentLoaded) {
            return;
        }
        if (hasPreloadStarted.current) {
            return;
        }
        preloadAssetsInHead();
        maybePreloadSoundsWithHowler();
        hasPreloadStarted.current = true;
    }, [isDocumentLoaded]);
    return null;
}
